import i18next from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";


// The translation denotes the default name space.
const resources = {
  en: { 
    default: require('../locales/en/default.json'),
    log:     require('../locales/en/log.json'),
    prop:     require('../locales/en/prop.json'),
  },
  sv: { 
    default: require('../locales/sv/default.json'),
    log:     require('../locales/sv/log.json'),
    prop:     require('../locales/sv/prop.json'),
  }
};

// All default options are provided in comments. 
const detection_options = {
  // // order and from where user language should be detected
  // order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],

  // // keys or params to lookup language from
  // lookupQuerystring: 'lng',
  // lookupCookie: 'i18next',
  // lookupLocalStorage: 'i18nextLng',
  // lookupSessionStorage: 'i18nextLng',
  // lookupFromPathIndex: 0,
  // lookupFromSubdomainIndex: 0,

  // // cache user language on
  // caches: ['localStorage', 'cookie'],
  // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // // optional expire and domain for set cookie
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain',

  // // optional htmlTag with lang attribute, the default is:
  // htmlTag: document.documentElement,

  // // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
  // cookieOptions: { path: '/', sameSite: 'strict' }
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    detection:     detection_options,
    fallbackLng:   'en',
    supportedLngs: ["en", "sv"],
    ns:            ["default", "log", "prop"],
    fallbackNS:    "default",
    defaultNS:     "default",
    // debug: true,
    interpolation: {
      escapeValue: false,
    },
  });
export default i18next;